module.exports = __webpack_public_path__ + "img/icon3.fc9c1f7.webp";